import { render } from "./_TextBlock.vue?vue&type=template&id=4e7f1e7c"
import script from "./_TextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./_TextBlock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/_TextBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e7f1e7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e7f1e7c', __exports__)) {
    api.reload('4e7f1e7c', __exports__)
  }
  
  module.hot.accept("./_TextBlock.vue?vue&type=template&id=4e7f1e7c", () => {
    api.rerender('4e7f1e7c', render)
  })

}


export default __exports__